import { useLocation } from 'react-router-dom';
import { PROTECTED_PATH } from 'shared/constants';
import { getPathWithoutLang } from 'shared/lib/converter';
import { useInfoStore } from 'store/useInfoStore';

/**
 * @description
 * 보호된 경로에 대한 인증 체크를 담당하는 custom hook입니다.
 * 다국어 경로를 고려하여 언어 코드를 제거한 후 보호된 경로인지 확인하고,
 * 로그인이 필요한 경우 자동으로 로그인 모달을 표시합니다.
 */
export const useProtectedPath = () => {
  const { pathname } = useLocation();
  const { accessToken, email } = useInfoStore();

  // 로그인 상태 확인
  const isLogin = email !== '' && accessToken !== '';

  // 언어 코드가 제거된 경로
  const pathWithoutLang = getPathWithoutLang(pathname);

  // 보호된 경로인지 확인
  const isProtectedPath = PROTECTED_PATH.some((path) => pathWithoutLang.startsWith(path));

  return {
    isLogin,
    isProtectedPath,
    pathWithoutLang,
  };
};
